'use client';

import { Button } from '@/components/ui/button';
import { Icons } from "@/components/shared/icons";
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  useEffect(() => {
    console.error('Error occurred:', error);
    
    const timer = setTimeout(() => {
      reset();
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [error, reset]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center space-y-4">
      <Icons.warning className="size-12 text-destructive" />
      <div className="text-center space-y-2">
        <h2 className="text-lg font-semibold">出现了一些问题</h2>
        <p className="text-sm text-muted-foreground">
          系统将在3秒后自动重试
        </p>
      </div>
      <div className="flex gap-3">
        <Button
          variant="default"
          onClick={() => reset()}
          className="min-w-[100px]"
        >
          立即重试
        </Button>
        <Button
          variant="outline"
          onClick={() => router.back()}
          className="min-w-[100px]"
        >
          返回上页
        </Button>
      </div>
    </div>
  );
}